<template>
    <div id="balanceRecharge">
        <div class="balanceRecharge-top">
            <div class="alreadySetUp">
            	<p>{{money_format(userAccount.amount/100, 2, '.', ',')}}</p>
				<h3>账户余额</h3>
            	<h1>ICCID:{{ this.$store.state.recordLoginText }}</h1>
				<!-- <img src="../../assets/home/refresh.png" /> -->
            </div>
        </div>

        <div class="balanceRecharge-middle">
            <h1 style="color:#333;">充值金额</h1>
			<div class="package-choose">
            	<div class="package-choose-item" v-for="(item, index) in packageChoose" :key="index"
            	:class="{'package-item-action': currentItem === index}"
            	@click="changeState(index, item[0], item[1])">
        			<h1>{{ item[0] }}元</h1>
        			<p>到账{{ item[1] }}元</p>
            	</div>
				<!-- <div class="package-choose-item package-choose-item-defined" 
            	:class="{'package-item-action': currentItem === 999}"
            	@click="showPackageItemDefined(999)"
            	>
        			<h1>自定义</h1>
            	</div> -->
	        </div>
        </div>

        <div class="balanceRecharge-action-btn">
            <button @click="btnActionRecharge()">充 值</button>
        </div>

        <div class="balanceRecharge-tip">
           <h1>温馨提醒</h1>
            <p>1、保持卡内余额大于10元，3个月没有使用记录自动注销。</p>
            <p>2、每月24号前订购次月流量，否则影响使用。</p>
            <p>3、提前订购流量，避免流量用完停机。</p>
        </div>


        <div class="checkstand-defined" v-show="popup">
	        <div class="van-overlay" style="z-index:91;" @click="closePopup()"></div>

	        <div class="checkstand-defined-popup" >
	        	<van-icon name="close" size='24' color="#dc4d4d"
	        	class="close-icon" @click="closePopup()"/>
		        <h1>请输入金额</h1>
		        <van-divider />
		        <div class="input-defined">
		        	<span>￥</span>
				  	<van-field
					  readonly
					  placeholder="点此输入"
					  clickable
					  :value="definedPrice"
					  @touchstart.native.stop="showKeyboard = true"
					/>
				</div>
	        	
	        	<div class="btn-defined">
	        		<button @click="btnActionRechargeDefined()"> 充 值</button>
	        	</div>	        	
	    	</div>

	    	<van-number-keyboard
			  :show="showKeyboard"
			  v-model="definedPrice"
			  theme="custom"
			  extra-key="."
			  close-button-text="完成"
			  @blur="showKeyboard = false"
			/>
	    </div>




	    <!-- 密码框   -->
	    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
	    <div class="van-popup van-popup--round van-popup--center changePasswordPanel-balanceRecharge" 
	        style="z-index: 2000; min-height: 25%; min-width: 80%;"
	        v-show="showPasswordPanel"
	        :style="{top:passwordPanelTop+'%'}"
	    >   

	    	<van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
	        
	        <!-- 密码输入框 -->
	        <p>设置支付密码：</p>
	        <van-password-input
	          :value="password"
	          :focused="passwordKeyboard"
	          @focus="passwordOnfocus()"
	        />

	        <!-- 再次确认密码输入框 -->
	        <p>再次确认密码：</p>
	        <van-password-input
	          :value="confirmPassword"
	          :focused="confirmPasswordKeyboard"
	          @focus="confirmPasswordOnfocus()"
	        />
	        <div class="confirmChangePassword">
	          <van-button class="confirmChangePasswordBtn" plain hairline  type="info" @click="sureToRecharge()">确 定</van-button>
	        </div>
	        
	    </div>

	    <!-- 数字键盘 -->
	    <van-number-keyboard
	      :z-index="2015"
	      :show="passwordKeyboard"

	      @input="passwordOnInput"
	      @delete="passwordOnDelete"
	      @blur="passwordKeyboard = false"
	    />

	    <van-number-keyboard
	      :z-index="2015"
	      :show="confirmPasswordKeyboard"

	      @input="confirmPasswordOnInput"
	      @delete="confirmPasswordOnDelete"
	      @blur="confirmPasswordKeyboard = false"
	    />
	    <!-- 数字键盘 end -->
	    <!-- 密码框 end  -->



        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
			:typeStyle="typeStyle"/>
                
    </div>
    
</template>
<script>
import {wxRequest} from '@/api/user.js'

import Checkstand from "@/components/Checkstand";
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
    components: {
        Checkstand,
    },
    data(){
        return {
        	iccid:'',
		    packageChoose:[],

		    //当前余额套餐
		    currentItem: 0,
		    price: 0,
		    giftBalance: 0,

		    //自定义金额
		    popup: false,

		    //自定义键盘
		    showKeyboard: false,
      		definedPrice: '',

      		//收银台
      		dataToPay:{},
      		checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },

            //设置密码
            type:'',
            showPasswordPanel: false,
		    password:'',
		    confirmPassword: "",
	      	passwordKeyboard : false,
	      	confirmPasswordKeyboard : false,
	      	passwordPanelTop: 50,
		    alreadySetUp: false,


            userAccount:{
		        amount: 0,
			},
			typeStyle: 0 //余额充值入口为0
        }        
    },
    methods: { 
        
        closePopup(){
        	this.popup = false;
        },


        //输入完密码后点击 【确定】 时
        sureToRecharge(){
        	if(this.checkPassword()){
        		if(this.type=="recharge"){
	        		this.toRecharge();
	        	}else if(this.type=="rechargeDefined"){
	        		this.toRechargeDefined();
	        	}
        	}
        },

        btnActionRecharge(){
        	this.type = "recharge";
    		//若当前为自定义状态
        	if(this.currentItem == 999){
        		this.popup = true;
        	}else{
        		if(this.alreadySetUp){
        			this.sureToRecharge();
	        	}else{
	        		this.showPasswordPanel = true;
	        	}
        		
        	}       
    		        		
        },

        btnActionRechargeDefined(){
        	this.type = "rechargeDefined";

        	if(this.definedPrice == ""){
	    		Dialog.alert({
				  title: '提示',
				  message: '请输入金额'
				}).then(() => {});

				return false;
	    	}

	    	// if(this.definedPrice < 1){
        	// 	Dialog.alert({
			// 	  title: '提示',
			// 	  message: '金额过低'
			// 	}).then(() => {

			// 	});
			// 	return false;
        	// }


        	if(this.alreadySetUp){
        		this.sureToRecharge();
        	}
        	else{
        		this.showPasswordPanel = true;
        	}
    	
        },


        changeState(currentItem, price, giftBalance){
        	this.currentItem = currentItem;
        	this.price = price;
        	this.giftBalance = (giftBalance - price)*100;
        },

        //点击【自定义】时
        showPackageItemDefined(currentItem){
        	this.popup = true;
        	this.currentItem = currentItem;
        	this.price = null;
        	this.giftBalance = 0;
        },


        toRecharge(){
            var data = {                
                iccid: this.$store.state.iccid,
                amount: this.price*100,
                giftBalance: this.giftBalance,
                payPass: this.confirmPassword,
            }

            this.$store.state.showCheckstandSource = 'balanceRecharge';
            this.dataToPay = data;
            this.$store.state.showCheckstand = true;    

            this.cancelChangePassword();       
        },

        toRechargeDefined(){
    		var data = {                
                iccid: this.$store.state.iccid,
                amount: this.definedPrice*100 ,
                giftBalance: this.giftBalance,
                payPass: this.confirmPassword,
            }

            this.$store.state.showCheckstandSource = 'balanceRecharge';

            this.dataToPay = data;
            this.$store.state.showCheckstand = true;
			this.price = this.definedPrice;
            this.definedPrice = '';
            this.closePopup();

            this.cancelChangePassword();
        },


        /***   修改密码     ***/
	    passwordOnfocus(){
	        this.passwordKeyboard = true;
	        this.confirmPasswordKeyboard = false;
	        this.passwordPanelTop = 30;
	    },
	    passwordOnDelete() {
	      this.password = this.password.slice(0, this.password.length - 1);
	    },

	    passwordOnInput(key) {
	        this.password = (this.password + key).slice(0, 6);
	    },


	    confirmPasswordOnfocus(){
	        this.passwordKeyboard = false;
	        this.confirmPasswordKeyboard = true;
	        this.passwordPanelTop = 30;
	    },
	    confirmPasswordOnDelete() {
	      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
	    },

	    confirmPasswordOnInput(key) {
	        this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
	    },


	    cancelChangePassword(){
	      this.password = '';
	      this.confirmPassword = '';
	      this.passwordPanelTop = 50;
	      this.showPasswordPanel = false;
	    },

	    checkPassword(){
        	if(this.alreadySetUp){
        		return true;
        	}
        	if(this.password.length < 6){
        		Toast.fail("请设置六位支付密码");
        		return false;
        	}

        	if(this.password != this.confirmPassword){
        		Toast.fail("两次输入的密码不一致");
        		return false;
        	}
        	return true;
        },
	    

	    /***   修改密码  end   ***/

    },
    created(){
    	this.iccid = localStorage.getItem('iccid');
    	
    	wxRequest("sim/uniorder/param", {iccid:this.iccid}, "post").then(res => {
            if(res.data.code == 200 ){
            	for (let i=0; i < res.data.data.length; i++) {
            		let itme = [res.data.data[i].amount, (res.data.data[i].amount * 1)+(res.data.data[i].giftBalance*1)];
            		this.packageChoose.push(itme);
            	}

            	this.price = this.packageChoose[0][0];
            	this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0])*100;
				console.log(this.packageChoose)
				console.log(this.price)
				console.log(this.giftBalance)
            }else{
            	Toast.fail(res.data.message);
            }
        })

    },

    mounted() {
        let param = {
	        iccid: this.$store.state.iccid,
	        mobile: localStorage.getItem('mobile'),
	    }
	    wxRequest("sysUser/account/querySysUserAccount", param, "post").then(res => {
	        if(res.data.code == 200){
	          	this.userAccount = res.data.data;  
	          	this.alreadySetUp = true;   
	        }
	    });
    },

    beforeDestory(){
       
    }
}
</script>
<style scoped>

	#balanceRecharge .checkstand-defined-popup .van-field__control{
		font-size: 24px;
	}

	#balanceRecharge .checkstand-defined-popup input::-webkit-input-placeholder { 
		/* Chrome/Opera/Safari */ 
		font-size: 14px;
	}
	#balanceRecharge .checkstand-defined-popup input::-moz-placeholder { 
		/* Firefox 19+ */  
		font-size: 14px;
	}
	#balanceRecharge .checkstand-defined-popup input::-ms-input-placeholder { /* IE 10+ */ 
	 	font-size: 14px;
	}
	#balanceRecharge .checkstand-defined-popup input::-moz-placeholder { 
		/* Firefox 18- */ 
		font-size: 14px;
	}

	#balanceRecharge .passwordInput .van-field__control{
		height: 24px;
	}

	.changePasswordPanel-balanceRecharge [class*=van-hairline]::after{
	    border-color: #c4cedc;
	}
</style>

<style lang="less">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	#balanceRecharge{
		background: #fff;
		height: 100%;
		// padding: 10px;
		.balanceRecharge-top{
			min-height: 185px;
			padding: 25px 20px 10px 20px;
			margin-bottom: 20px; 
			background:url(../../assets/home/icon16.png) no-repeat center;
			// border-radius: 5px;
			p{
				margin-bottom: 10px;
				padding-left:10px;
				line-height:36px;
			}


			.alreadySetUp{
				text-align: center;
				position: relative;
				p{
					margin-bottom: 0px;
					padding: 10px 10px;
				    color: #fff;
				    font-size:2.5rem;
				    line-height: 24px;
				}
				h3{
					padding: 10px 10px;
					font-size:0.875rem;
					color: #fff;
				}
				h1{
					padding:10px 10px 20px 10px;
					font-size:1rem;
					color: #8AA0E0;
				}
				img{
					position: absolute;
					top: -5px;
					right: -10px;
				}
			}
		}

		.balanceRecharge-middle{
			width:92%;
			margin:0 auto;
			position: absolute;
			left:0;
			right:0;
			top:20%;
			box-shadow: 0px 2px 14px 0px rgba(234, 234, 234, 0.5);
			background:#fff;
			border-radius:0.625rem;
			h1{
				font-weight: bold;
				line-height: 30px;
				font-size:1rem;
				padding:21px 17px;
			}
			.package-choose{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				text-align: center;
				padding:0 17px;
			}
			
			.package-choose-item{
				height: 60px;
				margin-bottom: 20px;
				flex-basis: 30%;
				border-radius: 5px;
				border:1px solid #EEEDED;
				color: #FF6463;
				background: #fff;
				h1{
					font-weight: 400;
					font-size:1rem; 
					margin: 0;
					padding:2px 0;
				}
				p{
					color: #999;
				}
			}
			.package-choose-item-defined{
				h1{
					font-size:.857rem; 
					color: #96989D;
					line-height: 60px;
				}
			}
			.package-item-action{
				background: url(../../assets/home/icon15.png) no-repeat right bottom;
				background-size:20px;
			}

			
		}


		.balanceRecharge-action-btn{
			padding: 20px 0px 10px;
			color: #fff;
			width:92%;
			margin:15rem auto 0 auto;
			button{
				width: 100%;
				line-height:46px;
				border-radius: 8px;
				font-size: 14px;
				background:#1542C3;
				border:0px solid #282E3E;
			}
		}

		.balanceRecharge-tip{
			padding: 10px 0px;
			width:92%;
			margin: 0 auto;
			h1{
				color: #333;
				font-size:0.875rem;
				line-height:40px;
				font-weight: bold;
			}
			p{
				line-height:24px;
				color:#999999;
				font-size:0.75rem;
			}
		}

		.checkstand-defined{
			.checkstand-defined-popup{
				position: fixed;
			    background-color: #fff;
			    z-index: 92;
			    width: 80%;
			    min-height: 30%;
			    top: 30%;
			    left: 10%;
			    border-radius: 15px;

			    .input-defined{
			    	padding: 15px 0 0 30px;
			    	border-bottom: 1px solid #ccc;
			    	display: flex;

			    	span{
			    		display: inline-block;
			    		color: #3a3a3a;
			    		font-size: 16px;
			    		line-height: 47px;
			    	}
			    }

			    .btn-defined{
			    	padding:30px 15px 20px 15px;
			    	button{
			    		background:rgba(255,169,65,1);
						border:0px solid rgba(255,255,255,1);
				    	width: 100%;
				    	height: 36px;
				    	font-size: 18px;
				    	color: #fff;
				    	border-radius: 5px;
				    }
			    }
			}

			.close-icon{
				position: absolute;
				right: 5px;
				top: -15px;
			}

			h1{
				margin-top: 5px;
				font-size: 14px;
				line-height: 40px;
				text-align: center;
			}
		}
	}

	.changePasswordPanel-balanceRecharge{
	  padding: 10px;

	  .icon-cross{
	  	position: absolute; 
	  	right: 10px;
	  	font-size: 16px;
	  }

	  p{
	    margin: 10px 16px 0 16px;
	    line-height: 30px;
	  }

	  .confirmChangePassword{
	    display:flex;
	    justify-content: flex-end;
	    margin-top: 20px;

	    .confirmChangePasswordBtn{
	    	width: 80px;
	      	margin: 0 15px;
	    }
	  }


	}
</style>


